import { SWAP_REQUIRES_ASSISTANCE } from "../constants/errors";

export const SWAP_ASSISTANCE_FALLBACK =
  "Sorry, this requires assistance. Please contact Traffix support: call 949-361-5663 or e-mail sentinelsupport@traffixdevices.com.";

/**
 * The API refuses a device swap with 409 SWAP_REQUIRES_ASSISTANCE when the
 * device coming in has an expired license and the one going out brings
 * nothing valid either. Returns the message to show for that response, or
 * null for any other response so the caller handles it as usual.
 */
export async function swapAssistanceMessage(res) {
  if (!res || res.status !== 409) return null;

  const body = await res
    .clone()
    .json()
    .catch(() => null);
  const status = body && body.responseStatus;
  if (!status || status.errorCode !== SWAP_REQUIRES_ASSISTANCE) return null;

  return status.message || SWAP_ASSISTANCE_FALLBACK;
}
